import { AxiosError, AxiosResponse } from "axios";
import { IResponse, IServerError } from "../../../models/common";

import http from "../../../common/http-commons";

export const ImportDataService = {
	getImportData: async (
		clientId: string,
		navigateToLogout: (path: string) => void,
	): Promise<IServerError | IResponse | null | any> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/import-data/${clientId}/`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createImportData: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse | any> => {
		const screenTag = requestPayload.importDataPageName;
		const PanelTag = requestPayload.importDataCurrentPanelTag;
		const clientId = requestPayload.clientId;
		console.log("PanelTag", PanelTag);
		try {
			const response: AxiosResponse<any> = await http.post<any>(
				`/v1/${
					screenTag === "toggl"
						? `/toggl-schedule-and-time/employees/import?company_id=${clientId}`
						: screenTag === "agendrix"
							? `agendrix-schedule-and-time/employees/import?company_id=${clientId}`
								? `7-shifts-schedule-and-time/timesheets/import?company_id=${clientId}`
								: screenTag === "humanity" &&
									PanelTag === "humanity_api_settings"
							: // All Import Timesheet APIs
								screenTag === "when_i_work" && PanelTag === "import_timesheets"
								? `when-i-work-schedule-and-time/timesheets/import?company_id=${clientId}`
								: screenTag === "swipe_clock" &&
									  PanelTag === "import_timesheets"
									? `swipe-clock-schedule-and-time/timesheets/import?company_id=${clientId}`
									: screenTag === "zoho_people" &&
										  PanelTag === "import_timesheets"
										? `zoho-people-schedule-and-time/timesheets/import?company_id=${clientId}`
										: screenTag === "zoho_books" &&
											  PanelTag === "import_timesheets"
											? `zoho-book-schedule-and-time/timesheets/import?company_id=${clientId}`
											: screenTag === "easy_work_force" &&
												  PanelTag === "import_timesheets"
												? `easy-work-force-schedule-and-time/timesheets/import?company_id=${clientId}`
												: screenTag === "quick_books_time" &&
													  PanelTag === "import_timesheets"
													? `quick-books-schedule-and-time/timesheets/import?company_id=${clientId}`
													: screenTag === "work_flow_max" &&
														  PanelTag === "import_timesheets"
														? `work-flow-max-schedule-and-time/timesheets/import?company_id=${clientId}`
														: screenTag === "seven_shifts" &&
															  PanelTag === "import_timesheets"
															? `humanity-schedule-and-time/login?company_id=${clientId}`
															: screenTag === "humanity" &&
																  PanelTag === "import_timesheets"
																? `humanity-schedule-and-time/timesheets/import?company_id=${clientId}`
																: screenTag === "deputy" &&
																	  PanelTag === "import_timesheets"
																	? `deputy-schedule-and-time/timesheets/import?company_id=${clientId}`
																	: screenTag === "namely" &&
																		  PanelTag === "namely_api_settings"
																		? `namely-hr/connect?company_id=${clientId}`
																		: screenTag === "bamboo_hr" &&
																			  PanelTag === "bamboo_hr_api_settings"
																			? `bamboohr-hr/connect?company_id=${clientId}`
																			: screenTag
				}`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 404) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 404) {
				return axiosError.response;
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	createImportEmployees: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse | any> => {
		const screenTag = requestPayload.importDataPageName;
		const PanelTag = requestPayload.importDataCurrentPanelTag;
		const clientId = requestPayload.clientId;
		console.log("PanelTag", PanelTag);
		try {
			const response: AxiosResponse<any> = await http.post<any>(
				`/v1/${
					screenTag === "toggl"
						? `toggl-schedule-and-time/employees/import?company_id=${clientId}`
						: screenTag === "agendrix"
							? `agendrix-schedule-and-time/employees/import?company_id=${clientId}`
							: screenTag === "when_i_work"
								? `when-i-work-schedule-and-time/employees/import?company_id=${clientId}`
								: screenTag === "swipe_clock"
									? `swipe-clock-schedule-and-time/employees/import?company_id=${clientId}`
									: screenTag === "zoho_people"
										? `zoho-people-schedule-and-time/employees/import?company_id=${clientId}`
										: screenTag === "zoho_books"
											? `zoho-book-schedule-and-time/employees/import?company_id=${clientId}`
											: screenTag === "easy_work_force"
												? `easy-work-force-schedule-and-time/employees/import?company_id=${clientId}`
												: screenTag === "quick_books_time"
													? `quick-books-schedule-and-time/employees/import?company_id=${clientId}`
													: screenTag === "seven_shifts"
														? `7-shifts-schedule-and-time/employees/import?company_id=${clientId}`
														: screenTag === "humanity"
															? `humanity-schedule-and-time/employees/import?company_id=${clientId}`
															: screenTag === "deputy"
																? `deputy-schedule-and-time/employees/import?company_id=${clientId}`
																: screenTag === "humanity"
																	? `humanity-schedule-and-time/employees/import?company_id=${clientId}`
																	: screenTag === "hr_zoho_people"
																		? `zoho-people-hr-schedule-and-time/employees/import?company_id=${clientId}`
																		: screenTag === "hr_wize"
																			? `hrwize-hr-schedule-and-time/employees/import?company_id=${clientId}`
																			: screenTag === "workable"
																				? `workable-hr-schedule-and-time/employees/import?company_id=${clientId}`
																				: screenTag === "namely"
																					? `namely-hr-schedule-and-time/employees/import?company_id=${clientId}`
																					: screenTag === "bamboo_hr"
																						? `bamboo-hr-schedule-and-time/employees/import?company_id=${clientId}`
																						: screenTag
				}`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 404) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else if (axiosError && axiosError.status === 404) {
				return axiosError.response;
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},


	createLinkedEmployees: async (
		requestPayload: any,
	): Promise<any | IServerError | IResponse | any> => {
		const screenTag = requestPayload.importDataPageName;
		const PanelTag = requestPayload.importDataCurrentPanelTag;
		const clientId = requestPayload.clientId;
		console.log("PanelTag", PanelTag);
		try {
			const response: AxiosResponse<any> = await http.post<any>(
				`/v1/add-ones-account-settings/addons-linked-employee/`,
				requestPayload,
			);

			if (response.status === 200) {
				return response;
			} else if (response.status === 400) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				requestPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getLinkedEmployees: async (
		clientId: string,
		addOnsType: string,
		navigateToLogout: (path: string) => void,
	): Promise<IServerError | IResponse | null | any> => {
		if (!clientId) return null;
		try {
			const response: AxiosResponse<any> = await http.get<any>(
				`/v1/add-ones-account-settings/${clientId}/addons-linked-employee?add_ons_type=${addOnsType}/`,
			);

			if (response.status === 200) {
				return response.data;
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	delImportData: async (
		delPayload: any,
	): Promise<string | IServerError | IResponse | any> => {
		try {
			const response: AxiosResponse<string> = await http.delete<string>(
				`/v1/import-data/${delPayload.clientId}/`,
				// delPayload.importDataId
			);

			if (response.status === 204) {
				return "Import Data has been deleted successfully";
			} else if (response.status === 200) {
				return "Import Data has been deleted successfully";
			} else if (response.status === 500) {
				return {
					status: false,
					message: "Something went wrong.",
					error: true,
				};
			}

			return {
				status: false,
				message: "Something went wrong please try again later.",
			};
		} catch (error) {
			const axiosError = error as AxiosError;
			console.error("An error occurred:", axiosError);
			const errorMessage =
				axiosError.response && typeof axiosError.response.data === "string"
					? axiosError.response.data
					: "Unknown error";
			if (axiosError && axiosError.status === 401) {
				delPayload.navigateToLogout("/logout");
				return {
					status: false,
					message: "UnAuthrized",
				};
			} else {
				return {
					status: false,
					message: errorMessage,
				};
			}
		}
	},

	getLinkedEmployeesDDL: async ( 
		clientId: string,
		ImportDataPageName: string | undefined,
	): Promise<any | IServerError | IResponse | null> => {
		  if (!clientId) return null;
		  if (!ImportDataPageName) return null;
		  try {
		    const response: AxiosResponse<any[]> = await http.get<any[]>(
		      `/v1/linked-employees/ddl?company_id=${clientId}`,
		    );
		    if (response.status === 200) {
		      return response.data;
		    } else if (response.status === 400) {
		      return response;
		    }
		    return {
		      status: false,
		      message: "Something went wrong please try again later.",
		    };
		  } catch {}
		},
		// const fixedResponse = [
		// 	{
		// 		label: "Cost of Goods Sold",
		// 		value: "310",
		// 	},
		// 	{
		// 		label: "Advertising",
		// 		value: "400",
		// 	},
		// 	{
		// 		label: "Bank Fees",
		// 		value: "404",
		// 	},
		// 	{
		// 		label: "Cleaning",
		// 		value: "408",
		// 	},
		// 	{
		// 		label: "Consulting & Accounting",
		// 		value: "412",
		// 	},
		// ];
		// return new Promise((resolve) =>
		// 	setTimeout(() => resolve(fixedResponse), 1000),
		// );
	// },
};
